import { RiExternalLinkLine } from '@remixicon/react';
import classNames from 'classnames';

import { Link, Text, linkClassNames } from '@spotify-internal/encore-web';
import { AttachmentFragment } from '@spotify/confidence-graphql';
import { isSafeUrl } from '@spotify/plugin-confidence-artifacts-react';

import styles from './ExternalUrlArtifactContent.module.css';

interface ExternalUrlArtifactContentProps {
  artifact: AttachmentFragment;
  // Optional UI URL. Omit when the artifact has no navigable UI.
  href?: string;
  onOpen?: () => void;
  title?: string;
  fallbackTitle?: (artifact: AttachmentFragment) => string;
}

const defaultFallbackTitle = (artifact: AttachmentFragment) => artifact.uri;

export const ExternalUrlArtifactContent = ({
  artifact,
  href,
  onOpen,
  title,
  fallbackTitle = defaultFallbackTitle,
}: ExternalUrlArtifactContentProps) => {
  const label = title || artifact.displayName || fallbackTitle(artifact);
  const safeUrl = href && isSafeUrl(href) ? href : undefined;

  const renderContent = () => {
    if (onOpen) {
      return (
        <button
          type="button"
          onClick={onOpen}
          className={classNames(linkClassNames(), styles.link)}
         data-track-source-anchor="876fede95b;external-url-artifact-content-button">
          {label}
        </button>
      );
    }
    if (safeUrl) {
      return (
        <Link
          href={safeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
         data-track-source-anchor="1d107be9aa;external-url-artifact-content-link">
          {label}
          <RiExternalLinkLine size={14} />
        </Link>
      );
    }
    return <Text>{label}</Text>;
  };

  return <div className={styles.info}>{renderContent()}</div>;
};
